import { EnumHelper } from "@singularsystems/neo-core";

/**
 * Trade Distribution Type Enum
 * Mirrors the TradeDistributionTypes database table values
 */
export enum TradeDistributionTypeEnum {
    PDF = 1,
    CSV = 2
}

// Decorate enum for UI display
EnumHelper.decorateEnum(TradeDistributionTypeEnum, e => {
    e.describe(TradeDistributionTypeEnum.PDF, "PDF", "Trade Distributions sent as PDF via SFTP.");
    e.describe(TradeDistributionTypeEnum.CSV, "CSV", "Trade distributions sent as flat file via SFTP");
});
